export function isTimedExercise(ex) {
  return ex?.trackingType === 'timed';
}

export function isTimedSet(set) {
  return set?.durationMinutes !== undefined && set?.durationMinutes !== '';
}

export function isSetFilled(exercise, set) {
  if (!set) return false;
  if (isTimedExercise(exercise) || isTimedSet(set)) {
    return set.durationMinutes !== undefined && set.durationMinutes !== '';
  }
  return Boolean(set.reps) && set.weight !== undefined && set.weight !== '';
}

/** Prefills with completed:false must not count. Legacy sets without the flag still count if filled. */
export function isSetLogged(set) {
  if (!set) return false;
  if (set.completed === true) return true;
  if (set.completed === false) return false;
  return Boolean((set.reps && set.weight !== undefined && set.weight !== '') || (set.durationMinutes !== undefined && set.durationMinutes !== ''));
}

export function isSetComplete(exercise, set) {
  if (set?.completed === true) return true;
  if (set?.completed === false) return false;
  return isSetFilled(exercise, set);
}

export function workoutHasLoggedSets(workout) {
  return (workout?.exercises || []).some((ex) => (ex.sets || []).some(isSetLogged));
}

export function workoutHasContent(workout) {
  return (workout?.exercises || []).length > 0;
}

export function parseSetCount(setsReps) {
  const m = String(setsReps || '').match(/(\d+)\s*[x×]/i);
  if (m) return Math.min(8, Math.max(1, parseInt(m[1], 10)));
  return 3;
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`;
  return `${m}:${String(r).padStart(2, '0')}`;
}

export function countLoggedSets(exercises) {
  return (exercises || []).reduce((acc, ex) => acc + (ex.sets || []).filter(isSetLogged).length, 0);
}
